<template>
    <div>
        <div class="grid grid-cols-12 gap-6">
            <div class="hidden md:col-span-1 md:block" />
            <div class="col-span-12 text-left md:col-span-10">
                <h2>Literatura</h2>
                <div class="mt-5 mb-5">
                    <img
                        src="../../public/img/articles/literatura.webp"
                        alt=""
                        class="mb-1 aspect-auto w-full object-cover"
                    />

                    <span class="source"
                        >Literatura / Zdroj: Marek Lašťovka</span
                    >
                </div>
                <p class="mb-2 font-bold sm:mb-5">
                    Výběrový seznam tištěné literatury
                </p>

                <p class="mb-2 sm:mb-5">
                    Augusta Pavel (ed.),
                    <span class="italic">Kniha o Praze 1, </span>
                    Praha 1998.
                </p>

                <p class="mb-2 sm:mb-5">
                    Augusta Pavel (ed.),
                    <span class="italic">Kniha o Praze 3, </span>
                    Praha 1994.
                </p>

                <p class="mb-2 sm:mb-5">
                    Augusta Pavel (ed.),
                    <span class="italic">Kniha o Praze 4, </span>
                    Praha 1996.
                </p>

                <p class="mb-2 sm:mb-5">
                    Augusta Pavel (ed.),
                    <span class="italic">Kniha o Praze 11, </span>
                    Praha 1998.
                </p>

                <p class="mb-2 sm:mb-5">
                    Augusta Pavel (ed.),
                    <span class="italic">Kniha o Praze 13, </span>
                    Praha 2000.
                </p>

                <p class="mb-2 sm:mb-5">
                    Augusta Pavel (ed.),
                    <span class="italic">Kniha o Praze 14, </span>
                    Praha 2000.
                </p>

                <p class="mb-2 sm:mb-5">
                    Augusta Pavel (ed.),
                    <span class="italic">Kniha o Praze 15, </span>
                    Praha 2003.
                </p>

                <p class="mb-2 sm:mb-5">
                    Augusta Pavel – Broncová Dagmar (editoři),
                    <span class="italic">Pražské radnice, </span>
                    Praha 2002.
                </p>

                <p class="mb-2 sm:mb-5">
                    Bartoš Petr – Břečka Jaroslav – Dudek František –
                    Missbichler Jiří,
                    <span class="italic"
                        >Kolovraty 1205–2005. Historie a současnost městské
                        části – Kolovraty,</span
                    >
                    Praha 2005.
                </p>

                <p class="mb-2 sm:mb-5">
                    Baťková Růžena a kol.,
                    <span class="italic"
                        >Umělecké památky Prahy. Nové Město, Vyšehrad,
                        Vinohrady,</span
                    >
                    Praha 1998.
                </p>

                <p class="mb-2 sm:mb-5">
                    Bečková Kateřina,
                    <span class="italic"
                        >Průvodce po Langweilově modelu Prahy,</span
                    >
                    Praha 1986.
                </p>

                <p class="mb-2 sm:mb-5">
                    Bečková Kateřina,
                    <span class="italic">Zmizelá Praha. Nové Město,</span>
                    Praha 1998.
                </p>

                <p class="mb-2 sm:mb-5">
                    Bečková Kateřina,
                    <span class="italic">Zmizelá Praha. Staré Město,</span>
                    Praha 2005.
                </p>

                <p class="mb-2 sm:mb-5">
                    Bečková Kateřina – Přikrylová Miroslava – Trnková Petra,
                    <span class="italic"
                        >Nejstarší fotografie Prahy 1850–1870,</span
                    >
                    Praha 2019.
                </p>

                <p class="mb-2 sm:mb-5">
                    Bělina Pavel a kol.,
                    <span class="italic"
                        >Dějiny Prahy. I., Od nejstarších dob do sloučení
                        pražských měst (1784),</span
                    >
                    Praha 1997,
                    <span class="italic"
                        >Dějiny Prahy. II., Od sloučení pražských měst v roce
                        1784 do současnosti,</span
                    >
                    Praha 1998.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic"
                        >Biografický slovník českých zemí,</span
                    >
                    sv. 1–23, Praha 2004–2020, dostupné též z:

                    <a
                        href="https://biography.hiu.cas.cz/wiki/Hlavn%C3%AD_strana"
                        target="_blank"
                        class="article-link"
                        >biography.hiu.cas.cz.</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    Broncová Dagmar (ed.),
                    <span class="italic">Kniha o Praze 5,</span>
                    Praha 1996.
                </p>

                <p class="mb-2 sm:mb-5">
                    Broncová Dagmar (ed.),
                    <span class="italic">Kniha o Zličínu a Sobínu,</span>
                    Praha 2005.
                </p>

                <p class="mb-2 sm:mb-5">
                    Bartoň Jiří – Picková Dagmar – Končel Josef,
                    <span class="italic"
                        >Petrovice v dějinách. Sborník k historii městské části
                        Praha-Petrovice,</span
                    >
                    Praha-Petrovice 1994.
                </p>

                <p class="mb-2 sm:mb-5">
                    Boháčová Ivana – Podliska Jaroslav a kol.,
                    <span class="italic"
                        >Průvodce pražskou archeologií. Památky známé, neznámé i
                        skryté,</span
                    >
                    Praha 2017.
                </p>

                <p class="mb-2 sm:mb-5">
                    Böhm Josef,
                    <span class="italic"
                        >Monografie města Smíchova s dvěma polohopisnými
                        plány,</span
                    >
                    Smíchov 1882.
                </p>

                <p class="mb-2 sm:mb-5">
                    Čarek Jiří – Hlavsa Václav – Janáček Josef,
                    <span class="italic"
                        >Ulicemi města Prahy od 14. století do dneška,</span
                    >
                    Praha 1958.
                </p>

                <p class="mb-2 sm:mb-5">
                    Čvančara Jaroslav – Janík Vlastislav – Ledvinka Václav –
                    Šustek Vojtěch,
                    <span class="italic"
                        >Pamětní kniha 294 hrdinů a obětí heydrichiády
                        popravených v Mauthausenu,</span
                    >
                    Praha 2013.
                </p>

                <p class="mb-2 sm:mb-5">
                    David Jaroslav,
                    <span class="italic"
                        >Smrdov, Brežněves a Rychlonožkova ulice. Kapitoly z
                        moderní české toponymie,</span
                    >
                    Praha 2011.
                </p>

                <p class="mb-2 sm:mb-5">
                    Dragoun Zdeněk – Škabrada Jiří – Tryml Michal,
                    <span class="italic">Románské domy v Praze,</span>
                    Praha 2002.
                </p>

                <p class="mb-2 sm:mb-5">
                    Erben Karel Jaromír,
                    <span class="italic">
                        Autentický ukazatel ulic a náměstí i čísel domovních
                        královského hlavního města Prahy,</span
                    >
                    Praha 1870.
                </p>

                <p class="mb-2 sm:mb-5">
                    Fialová Ludmila,
                    <span class="italic"
                        >Charakteristiky pražských příměstských usedlostí a
                        jejich vývoj,</span
                    >
                    Acta Universitatis Carolinae 1973, Geographica No. 1., s.
                    27–53, Geographica No. 2., s. 47–72.
                </p>

                <p class="mb-2 sm:mb-5">
                    Filip František,
                    <span class="italic"
                        >Vinoř od minulosti k dnešku 1088–2002,</span
                    >
                    Praha 2004.
                </p>

                <p class="mb-2 sm:mb-5">
                    Fischer Jan – Fischer Ondřej,
                    <span class="italic">Pražské mosty,</span>
                    Praha 1985.
                </p>

                <p class="mb-2 sm:mb-5">
                    Hájek Josef a kol.,
                    <span class="italic"
                        >Cihly v historické architektuře Prahy. O výrobě a
                        využití zdicích cihel. Seznam pražských cihelen,</span
                    >
                    Praha 2017.
                </p>

                <p class="mb-2 sm:mb-5">
                    Hansl František a kol.,
                    <span class="italic">Smíchovsko a Zbraslavsko,</span>
                    Smíchov 1899.
                </p>

                <p class="mb-2 sm:mb-5">
                    Hlavsa Václav – Vančura Jiří,
                    <span class="italic"
                        >Malá Strana / Menší Město pražské,</span
                    >
                    Praha 1983.
                </p>

                <p class="mb-2 sm:mb-5">
                    Holec František,
                    <span class="italic"
                        >Kronika královské Prahy a obcí sousedních. Díl IV.,
                        Připojené obce a zaniklé osady,</span
                    >
                    Praha 1996.
                </p>

                <p class="mb-2 sm:mb-5">
                    Holec František – Mikota Miloslav,
                    <span class="italic"
                        >Počátky stavebního vývoje Žižkova,</span
                    >
                    Pražský sborník historický 1966, s. 130–147.
                </p>

                <p class="mb-2 sm:mb-5">
                    Holec František,
                    <span class="italic">O jménech pražských ulic,</span>
                    Praha 1983, č. 3, s. 30.
                </p>

                <p class="mb-2 sm:mb-5">
                    Holec František,
                    <span class="italic"
                        >Zaniklé vesnice na území hlavního města Prahy,</span
                    >
                    Pražský sborník historický 1996, s. 117–151.
                </p>

                <p class="mb-2 sm:mb-5">
                    Hromádka Tomáš,
                    <span class="italic"> Malá a Velká Chuchle,</span>
                    Praha 2010.
                </p>

                <p class="mb-2 sm:mb-5">
                    Hrubeš Josef – Hrubešová Eva,
                    <span class="italic">Pražské ostrovy,</span>
                    Praha 2007.
                </p>

                <p class="mb-2 sm:mb-5">
                    Jásek Jaroslav,
                    <span class="italic"
                        >William Heerlein Lindley a pražská kanalizace,</span
                    >
                    Praha 2006.
                </p>

                <p class="mb-2 sm:mb-5">
                    Jásek Jaroslav – Drnek Kryštof,
                    <span class="italic"
                        >Vodovody předměstských obcí před vznikem Velké
                        Prahy,</span
                    >
                    Praha 2020.
                </p>

                <p class="mb-2 sm:mb-5">
                    Jíšová Kateřina – Lašťovka Marek – Lašťovková Barbora –
                    Třikač Josef,
                    <span class="italic"
                        >Pražský uličník. Encyklopedie názvů pražských veřejných
                        prostranství, 3. díl,</span
                    >
                    Praha 2012.
                </p>

                <p class="mb-2 sm:mb-5">
                    Kalousková Lenka,
                    <span class="italic">
                        Problematika dvojjazyčných česko-německých
                        hodonym,</span
                    >
                    Acta Oeconomica Pragensia 2006 (vol. 14), č. 4, s. 69–75.
                </p>

                <p class="mb-2 sm:mb-5">
                    Kohout Jiří – Vančura Jiří,
                    <span class="italic">
                        Praha 19. a 20. století. Technické proměny,</span
                    >
                    Praha 1986.
                </p>

                <p class="mb-2 sm:mb-5">
                    Kožušková Hana,
                    <span class="italic"> Vznik názvů ulic v Praze 8,</span>
                    Praha 1988.
                </p>

                <p class="mb-2 sm:mb-5">
                    Krákorová Jaroslava – Jansenová Ayen – Tryml Michal –
                    Šmolíková Miroslava,
                    <span class="italic">Dolní Chabry,</span>
                    Praha 2006.
                </p>

                <p class="mb-2 sm:mb-5">
                    Krákorová Jaroslava – Řeháková Renáta – Švéda Jan,
                    <span class="italic"
                        >Čakovice, Miškovice, Třeboradice,</span
                    >
                    Praha 2005.
                </p>

                <p class="mb-2 sm:mb-5">
                    Křížová Lenka – Martínek Jiří a kol.,
                    <span class="italic"
                        >Od Karlova mostu ke Gottwaldovu: Osobnosti v názvech
                        měst a míst,</span
                    >
                    Praha 2017.
                </p>

                <p class="mb-2 sm:mb-5">
                    Kuranda Miroslav,
                    <span class="italic">Nástin historie Hrdlořez,</span>
                    Praha 1969.
                </p>

                <p class="mb-2 sm:mb-5">
                    Lašťovka Marek – Lašťovková Barbora,
                    <span class="italic"
                        >Plán Prahy podle indikačních skic stabilního katastru
                        (1840–1842),</span
                    >
                    Praha 2005.
                </p>

                <p class="mb-2 sm:mb-5">
                    Lašťovka Marek – Lašťovková Barbora,
                    <span class="italic"
                        >Plán Prahy a Vyšehradu na základě mapování stabilního
                        katastru (1856),</span
                    >
                    Praha 2008.
                </p>

                <p class="mb-2 sm:mb-5">
                    Lašťovka Marek – Lašťovková Barbora,
                    <span class="italic"
                        >Pražské uliční názvy jako prostředek orientace i
                        nástroj ideologie 1945–1990,</span
                    >
                    Documenta Pragensia 2011, č. 30, s. 313–324.
                </p>

                <p class="mb-2 sm:mb-5">
                    Lašťovka Marek – Lašťovková Barbora,
                    <span class="italic"
                        >Proměny pražského uličního názvosloví v letech
                        1945–1990,</span
                    >
                    Pražský sborník historický 2019, s. 379–393.
                </p>

                <p class="mb-2 sm:mb-5">
                    Lašťovka Marek – Ledvinka Václav a kol.,
                    <span class="italic"
                        >Pražský uličník. Encyklopedie názvů pražských veřejných
                        prostranství 1., 2.,</span
                    >
                    Praha 1997–1998.
                </p>

                <p class="mb-2 sm:mb-5">
                    Lašťovková Barbora,
                    <span class="italic">Pražské usedlosti,</span>
                    Praha 2016.
                </p>

                <p class="mb-2 sm:mb-5">
                    Ledvinka Václav – Pešek Jiří,
                    <span class="italic">Praha,</span>
                    Praha 2000.
                </p>

                <p class="mb-2 sm:mb-5">
                    Lorenc Vilém,
                    <span class="italic">Nové Město pražské,</span>
                    Praha 1973.
                </p>

                <p class="mb-2 sm:mb-5">
                    Marek Jindřich – Pejčoch Ivo – Plachý Jiří – Jakl Tomáš,
                    <span class="italic"
                        >Padli na barikádách. Padlí a zemřelí ve dnech Pražského
                        povstání 5.–9. května 1945,</span
                    >
                    Praha 2015.
                </p>

                <p class="mb-2 sm:mb-5">
                    Mendelová Jaroslava – Státníková Pavla – Fiala Michal,
                    <span class="italic"> Nové Město pražské 1348–1784,</span>
                    Praha: Muzeum hlavního města Prahy, 1998.
                </p>

                <p class="mb-2 sm:mb-5">
                    Míka Zdeněk a kol.,
                    <span class="italic">Dějiny Prahy v datech,</span>
                    Praha 1999.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic">Minulost a současnost Prahy 10,</span>
                    Praha 1975.
                </p>

                <p class="mb-2 sm:mb-5">
                    Moravec Jaroslav,
                    <span class="italic"
                        >František Červený – muzikant, podnikatel,
                        vynálezce,</span
                    >
                    Dubeč 1996.
                </p>

                <p class="mb-2 sm:mb-5">
                    Moutvic Miroslav,
                    <span class="italic"
                        >Dvorce přemyslovských družiníků a vývoj Prahy
                        románského období,</span
                    >
                    Pražský sborník historický 1989, s. 7–33.
                </p>

                <p class="mb-2 sm:mb-5">
                    Orián Edmund (ed.),
                    <span class="italic"
                        >Praha na dobových pohlednicích 1886–1930,</span
                    >
                    Praha 1998.
                </p>

                <p class="mb-2 sm:mb-5">
                    Orián Edmund (ed.),
                    <span class="italic"
                        >Židovské město pražské na vedutách, fotografiích a
                        pohlednicích,</span
                    >
                    Praha 2004.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic"
                        >Orientační kniha Velké Prahy a Modřan,</span
                    >
                    Praha 1948.
                </p>

                <p class="mb-2 sm:mb-5">
                    Pacner Miroslav (sest.),
                    <span class="italic"
                        >Řeporyje: ohlédnutí za minulostí,</span
                    >
                    Praha 2001.
                </p>

                <p class="mb-2 sm:mb-5">
                    Eva Semotanová (red.),
                    <span class="italic"
                        >Praha – Královské Vinohrady. Historický atlas měst
                        České republiky, sv. 19,</span
                    >
                    Praha 2010.
                </p>

                <p class="mb-2 sm:mb-5">
                    Eva Semotanová (red.),
                    <span class="italic"
                        >Praha – Libeň. Historický atlas měst České republiky,
                        sv. 14,</span
                    >
                    Praha 2006.
                </p>

                <p class="mb-2 sm:mb-5">
                    Eva Chodějovská (red.),
                    <span class="italic">
                        Praha – Smíchov. Historický atlas měst České republiky,
                        sv. 24,</span
                    >
                    Praha 2013.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic">Pražské historické zahrady,</span>
                    Praha 2007.
                </p>

                <p class="mb-2 sm:mb-5">
                    Prix Dalibor a kol.,
                    <span class="italic"
                        >Umělecké památky Prahy. Velká Praha M/Ž,
                    </span>
                    Praha 2017.
                </p>

                <p class="mb-2 sm:mb-5">
                    Procházka Karel,
                    <span class="italic"> Památky žižkovské I., </span>
                    Praha 1924.
                </p>

                <p class="mb-2 sm:mb-5">
                    Přikrylová Miroslava,
                    <span class="italic"
                        >Fotografický ateliér H. Eckert v Praze. Obrazový
                        katalog fotografií uložených v Archivu hl. m.
                        Prahy,</span
                    >
                    Praha 2017.
                </p>

                <p class="mb-2 sm:mb-5">
                    Ptáčníková Martina,
                    <span class="italic"
                        >Pražská honorifikační urbanonyma v období 1945–1989 a
                        jejich podíl na formování identity socialistického
                        velkoměsta, disertační práce,</span
                    >
                    Filozofická fakulta Univerzity Karlovy 2019.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic">Rohožník – dubečský zpravodaj.</span>
                    Místní časopis.
                </p>

                <p class="mb-2 sm:mb-5">
                    Roubík František,
                    <span class="italic"
                        >Silnice v Čechách a jejich vývoj,</span
                    >
                    Praha 1938.
                </p>

                <p class="mb-2 sm:mb-5">
                    Rudl Aleš,
                    <span class="italic"
                        >Běchovický uličník. Průvodce historií a současností
                        ulic MČ Praha-Běchovice,</span
                    >
                    Praha 2013.
                </p>

                <p class="mb-2 sm:mb-5">
                    Ruth František,
                    <span class="italic"
                        >Kronika královské Prahy a obcí sousedních I–III,</span
                    >
                    Praha 1903–1904.
                </p>

                <p class="mb-2 sm:mb-5">
                    Semotanová Eva a kol.,
                    <span class="italic"> Ottův historický atlas Praha,</span>
                    Praha 2016.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic"
                        >Seznam domovních čísel a majitelů domů na
                        Zbraslavi,</span
                    >
                    s.d.
                </p>

                <p class="mb-2 sm:mb-5">
                    Smrž Jiří,
                    <span class="italic"
                        >Cechy v pražských městech od prvních zpráv ve 13.
                        století až do jejich zrušení v roce 1860,</span
                    >
                    Praha 2019.
                </p>

                <p class="mb-2 sm:mb-5">
                    Srb Adolf – Houba Josef,
                    <span class="italic">Město Žižkov,</span>
                    Žižkov 1910.
                </p>

                <p class="mb-2 sm:mb-5">
                    Stehlík František,
                    <span class="italic"
                        >Historický orientační průvodce ulicemi hlavního města
                        Prahy,</span
                    >
                    Praha 1925.
                </p>

                <p class="mb-2 sm:mb-5">
                    Šťastná Jarmila,
                    <span class="italic"
                        >Pražské trhy a tržiště od konce 18. do počátku 20.
                        století,</span
                    >
                    Český lid 67, 1980, s. 5–19.
                </p>

                <p class="mb-2 sm:mb-5">
                    Štěpán Pavel,
                    <span class="italic"
                        >Lokální urbanonymické systémy, Zborník príspevkov z
                        XVIII. kolokvia mladých jazykovedcov (Prešov – Kokošovce
                        – Sigord 3.–5. 12. 2008),</span
                    >
                    Prešov 2009.
                </p>

                <p class="mb-2 sm:mb-5">
                    Štěpánek Ladislav,
                    <span class="italic"
                        >Vývoj pražských nouzových kolonií a život jejich
                        obyvatel,</span
                    >
                    Pražský sborník historický 1978, č. 11, s. 139–151.
                </p>

                <p class="mb-2 sm:mb-5">
                    Teige Josef,
                    <span class="italic"
                        >Základy starého místopisu Pražského I, II,
                    </span>
                    Praha 1910–1915.
                </p>

                <p class="mb-2 sm:mb-5">
                    Tomaidesovi Marie a Antonín,
                    <span class="italic"> Střípky z újezdské historie,</span>
                    Praha 2009.
                </p>

                <p class="mb-2 sm:mb-5">
                    Tomek Václav Vladivoj,
                    <span class="italic">Dějepis města Prahy I–XII,</span>
                    Praha 1855–1897.
                </p>

                <p class="mb-2 sm:mb-5">
                    Tomek Václav Vladivoj,
                    <span class="italic">
                        Základy starého místopisu Pražského I–V,
                        1865–1875.</span
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    Tomeš Josef,
                    <span class="italic">Libeňskou minulostí,</span>
                    Praha 1989.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic"
                        >Uhříněves a okolí. Historie a současnost městské části
                        Praha 22,</span
                    >
                    Praha 2003.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic"
                        >Uliční jízdní řád pro hlavní město Prahu,</span
                    >
                    sest. Přáda Josef a Rosenbach František, Praha 1931.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic"
                        >Úřední seznam ulic, náměstí a sadů hlavního města
                        Prahy,</span
                    >
                    Praha 1940.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vacek František,
                    <span class="italic"
                        >Dějiny Dejvic, Bubenče, Šárky a okolí,</span
                    >
                    Sborník příspěvků k dějinám král. hl. města Prahy II. a IV.,
                    Praha 1911 a 1923.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vančura Jiří,
                    <span class="italic"> Hradčany, Pražský hrad,</span>
                    Praha 1976.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vlček Pavel a kol.,
                    <span class="italic"
                        >Umělecké památky Prahy. Malá Strana,</span
                    >
                    Praha 1999.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vlček Pavel a kol.,
                    <span class="italic">
                        Umělecké památky Prahy. Pražský hrad a Hradčany,</span
                    >
                    Praha 2000.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vlček Pavel a kol.,
                    <span class="italic"
                        >Umělecké památky Prahy. Staré Město, Josefov,</span
                    >
                    Praha 1996.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vlček Pavel a kol.,
                    <span class="italic"
                        >Umělecké památky Prahy. Velká Praha A/L,</span
                    >
                    Praha 2012.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vlček Pavel – Sommer Petr – Foltýn Dušan,
                    <span class="italic">Encyklopedie českých klášterů,</span>
                    Praha 1997.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vojtíšek Václav,
                    <span class="italic"
                        >K otázce pražských uličních jmen,</span
                    >
                    Věstník hl. m. Prahy 1928, č. 39–40, s. 884–886, 905–908.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vojtíšek Václav,
                    <span class="italic"
                        >O starých jménech pražských ulic,</span
                    >
                    Naše řeč 1940, č. 24, s. 97–103.
                </p>

                <p class="mb-2 sm:mb-5">
                    Vondra Roman,
                    <span class="italic"
                        >Karel hrabě Chotek z Chotkova a Vojnína
                        (1783–1868),</span
                    >
                    Historický obzor 18, 2007, č. 5–6, s. 120–132.
                </p>

                <p class="mb-2 sm:mb-5">
                    Wimmer Miloslav a kol.,
                    <span class="italic"> Ďáblice,</span>
                    Praha 2000.
                </p>

                <p class="mb-2 sm:mb-5">
                    nazev článku
                    <span class="italic">Zbraslavské noviny.</span>
                    Místní časopis, 1996.
                </p>

                <p class="mb-2 sm:mb-5">
                    Zdeňková Marie,
                    <span class="italic">Antonín Švehla a Hostivař,</span>
                    Praha 2008.
                </p>

                <p class="mb-2 sm:mb-5">
                    <span class="italic">Zpravodaj Klubu přátel Žižkova.</span>
                </p>

                <p class="mb-2 sm:mb-5">
                    Židlík Alois,
                    <span class="italic"
                        >Problém tzv. řemeslnických ulic v Praze. Několik
                        příspěvků k dějinám Prahy,</span
                    >
                    Filozofická fakulta Univerzity Karlovy, Katedra pomocných
                    věd historických a archivního studia, Praha 1968.
                </p>

                <p class="mb-2 font-bold">Internetové zdroje</p>
                <p class="underline">mapové portály:</p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://dveprahy.cz/"
                        target="_blank"
                        class="article-link"
                        >dveprahy.cz</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://ags.cuzk.gov.cz/archiv/"
                        target="_blank"
                        class="article-link"
                        >ags.cuzk.gov.cz/archiv</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.oldmapsonline.org/"
                        target="_blank"
                        class="article-link"
                        >oldmapsonline.org</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://geoportalpraha.cz/"
                        target="_blank"
                        class="article-link"
                        >geoportalpraha.cz</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://geoportal.cuzk.cz/"
                        target="_blank"
                        class="article-link"
                        >geoportal.cuzk.cz</a
                    >
                </p>

                <p class="underline">ostatní:</p>
                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.ahmp.cz/"
                        target="_blank"
                        class="article-link"
                        >ahmp.cz</a
                    >
                    (Archiv hl. m. Prahy, kde lze nalézt mnohé historické
                    informace o Praze, její správě v minulosti, a také archivní
                    katalog)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://cs.wikipedia.org/"
                        target="_blank"
                        class="article-link"
                        >cs.wikipedia.org</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://cuzk.gov.cz/"
                        target="_blank"
                        class="article-link"
                        >cuzk.gov.cz</a
                    >
                    (Český úřad zeměměřický a katastrální)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.vhu.cz/"
                        target="_blank"
                        class="article-link"
                        >vhu.cz</a
                    >
                    (Vojenský historický ústav)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://valecnehroby.mo.gov.cz/evidence-valecnych-hrobu"
                        target="_blank"
                        class="article-link"
                        >valecnehroby.mo.gov.cz/evidence-valecnych-hrobu</a
                    >
                    (evidence válečných hrobů)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.pametni-desky-v-praze.cz/"
                        target="_blank"
                        class="article-link"
                        >pametni-desky-v-praze.cz</a
                    >
                    (evidence válečných hrobů)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.sources.cms.flu.cas.cz/"
                        target="_blank"
                        class="article-link"
                        >sources.cms.flu.cas.cz</a
                    >
                    (edice pramenů pro středověk)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.zhola.com/praha/zanikleKostely/"
                        target="_blank"
                        class="article-link"
                        >zhola.com/praha/zanikleKostely</a
                    >
                    (evidence pražských zaniklých kostelů)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.vets.cz/"
                        target="_blank"
                        class="article-link"
                        >vets.cz</a
                    >
                    (Spolek pro vojenská pietní místa)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.prahaneznama.cz/"
                        target="_blank"
                        class="article-link"
                        >prahaneznama.cz</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.vodnimlyny.cz/"
                        target="_blank"
                        class="article-link"
                        >vodnimlyny.cz</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.pamatkovykatalog.cz/"
                        target="_blank"
                        class="article-link"
                        >pamatkovykatalog.cz</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.bahnoprahy.cz/"
                        target="_blank"
                        class="article-link"
                        >bahnoprahy.cz</a
                    >
                    (informační portál o pražských nouzových koloniích)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.novanobilitas.eu/"
                        target="_blank"
                        class="article-link"
                        >novanobilitas.eu</a
                    >
                    (informační portál o nové šlechtě v habsburské monarchii)
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.sochyamesta.cz/"
                        target="_blank"
                        class="article-link"
                        >sochyamesta.cz</a
                    >
                </p>

                <p class="mb-2 sm:mb-5">
                    <a
                        href="https://www.zastarouprahu.cz/"
                        target="_blank"
                        class="article-link"
                        >zastarouprahu.cz</a
                    >
                    (internetové stránky Klubu Za starou Prahu)
                </p>

                <p class="mb-10 sm:mb-25">
                    <a
                        href="https://www.digitalniknihovna.cz/"
                        target="_blank"
                        class="article-link"
                    >
                        digitalniknihovna.cz</a
                    >
                    (poskytuje nejen mnohé zdigitalizované knihy a slovníky,
                    např. Ottův slovník naučný, ale také třeba Evidenci obětí
                    Pražského povstání Oblastní kriminální úřadovny Praha)
                </p>

                <!-- next chapters -->
                <div class="mb-10 flex justify-between border-t-1 pt-5">
                    <p class="mb-5 w-1/2 border-r-1 font-bold">
                        <nuxt-link
                            to="/clanky/ostatni-prameny"
                            class="flex justify-start underline"
                        >
                            <img
                                src="../../public/img/left-arrow.png"
                                alt=""
                                class="order-1 mr-2 inline h-5 w-5"
                            />
                            <span class="order-2 mr-2">Ostatní prameny</span>
                        </nuxt-link>
                    </p>
                    <p class="mb-5 font-bold">
                        <!-- nothing -->
                    </p>
                </div>
            </div>
            <div class="hidden md:col-span-1 md:block" />
        </div>

        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
